export default __webpack_public_path__ + "static/media/eight.d801653e.ogg";